exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{background-color:#fff}.popover{z-index:1000000;max-width:450px;border-radius:3px;box-shadow:5px 5px 3px #a4a4a4}.popover-header{background-color:#ce005d;color:#fff;font-size:15px;font-weight:200}.popover-body{color:#706e7b;font-size:20px}", ""]);

// exports
